import {on, trigger} from './util/event'
import api from './api'


const changeEventName               = 'change.kiosk.userInteresting',
      successChangeEventName        = 'changed.kiosk.userInteresting',
      typeCategory                  = 'category',
      typeMagazine                  = 'magazine',
      categoryFavoritePath          = '/api/category-favorite/',
      magazineFavoritePath          = '/api/magazine-favorite/',

      categoryCountSelector         = '#interesting-category-select .count, #interesting-category-menu > .nav-link .count, #mobile-interesting-category-menu > .nav-link .count',
      magazineCountSelector         = '#interesting-magazine-select .count, #interesting-magazine-menu > .nav-link .count, #mobile-interesting-magazine-menu > .nav-link .count',
      categoryMenuContainerSelector = '#interesting-category-menu > .dropdown-menu, #collapse-mobile-interesting-category-menu',
      magazineMenuContainerSelector = '#interesting-magazine-menu > .dropdown-menu, #collapse-mobile-interesting-magazine-menu'

;

on(changeEventName, function(e) {

  let url         = null;
  const eventData = e.detail,
      type        = eventData.in_favorite ? 'put' : 'delete',
      id          = parseInt(eventData.id) || null
  ;

  // TODO Event classes with data fields ???
  // {"type": "category", "id": $input.val(), "in_favorite": $input.prop("checked")}
  switch (eventData.type) {
    case typeCategory:
      url = categoryFavoritePath;
      break;
    case typeMagazine:
      url = magazineFavoritePath;
      break;
    default:
      break;
  }
  if (url !== null) {
    api({
      method: type,
      url: url + id
    }).then((response) => {
      const data = response.data;
      if (data.result) {
        trigger(successChangeEventName, {type: eventData.type});
      }
    })

  }

});

on(successChangeEventName, function(e) {
  const eventData = e.detail;
  api({
    url: '/api/user-interesting',
    type: 'get',
    params: {type: eventData.type, html: true, count: true} // yii.csrf
  }).then((response) => {
    const data          = response.data;
    let $menuContainer  = null,
          $countElement = null;
    switch (eventData.type) {
      case typeCategory:
        $menuContainer = $(categoryMenuContainerSelector);
        $countElement  = $(categoryCountSelector);
        break;
      case typeMagazine:
        $menuContainer = $(magazineMenuContainerSelector);
        $countElement  = $(magazineCountSelector);
        break;
      default:
        break;
    }

    if (data !== undefined) {
      if (data.count !== undefined) {
        $countElement.html(data.count);
      }
      if (data.html !== undefined) {
        $menuContainer.html(data.html);
      }
    }
  })

});

const userInteresting = {
  changeEventName: changeEventName,
  changedEventName: successChangeEventName,
  typeCategory: typeCategory,
  typeMagazine: typeMagazine
};


export default userInteresting;